export let EditMoveConstraint;(function(t){t["XY"]="XY";t["Z"]="Z"})(EditMoveConstraint||(EditMoveConstraint={}));